export function isParticipationCancellation(eventType: string): boolean {
  return eventType === 'cancelled_early' || eventType === 'cancelled_late';
}
